var step = 1;
var steps = [];
var lang = $('html').attr('lang').substr(0, 2);

var editForm = $('#acf-form');
if(editForm.hasClass('projekt')) {
  var steps = [
    false,
    '.acf-field-619c93e2041c4',
    '.acf-field-619c9403041c5',
    '.acf-field-6194b5f36ba2a'
  ]
}
else if(editForm.hasClass('news')) {
  var steps = [
    false,
    '.acf-field-619c9687edc39',
    '.acf-field-619c96d3edc3a'
  ]
}
else if(editForm.hasClass('event')) {
  var steps = [
    false,
    '.acf-field-619c9974dffc3',
    '.acf-field-619c99b1dffc4'
  ]
}
else if(editForm.hasClass('netzwerk')) {
  var steps = [
    false,
    '.acf-field-619c99f764f2c',
    '.acf-field-61b88bab7f330'
  ]
}
else if(editForm.hasClass('diskussion')) {
  var steps = [
    false,
    '.acf-field-619c9ab4a1781',
    '.acf-field-619c9adca1782'
  ]
}

$(document).ready(function() {

  $('a.acf-button,a.acf-icon').attr('href',null);

  $('html:lang(de-CH) .acf-field-checkbox[data-name="translations"] input[value="de"]').parent().parent().hide();
  $('html:lang(fr-FR) .acf-field-checkbox[data-name="translations"] input[value="fr"]').parent().parent().hide();
  $('html:lang(it-IT) .acf-field-checkbox[data-name="translations"] input[value="it"]').parent().parent().hide();

  $('.acf-field-checkbox[data-name="translations"] input[type="checkbox"]').each(function() {
    if($(this).is(":checked")){
      $('.acf-form .acf-fields .acf-field:not(.acf-field-select,.acf-field-taxonomy).lang-'+$(this).val()).show();
      $('.acf-label label').addClass("show--lang");
    }
  });

  showStep(1);
  if($('.page-template-page-usercontent .acf-field-accordion').length) {
    var navigation = document.createElement("span");
    navigation.innerHTML = '<button class="btn" id="btn-back" disabled>'+lm_translations['back']+'</button>';
    if(($('#_acf_post_id').val() == 'new_post' || $('#acf-form').hasClass('draft')) && editForm.hasClass('projekt')) {
      navigation.innerHTML += '<button class="btn" id="btn-draft">'+lm_translations['draft']+'</button>';
    }
    navigation.innerHTML += '<button class="btn" id="btn-next">'+lm_translations['next']+'</button>';
    $('.acf-form-submit').prepend(navigation);
  }
  $('#btn-next').click(function(e) {
    e.preventDefault();
    if(step == 1) {
      
      var titel = $($('.acf-field-text[data-name="titel_'+lang+'"] input')[0]).val();
      var projekt = $($('.acf-field[data-name="projekt"] select')[0]).val();
      if(titel == '') {
        alert(lm_translations['choose_title']);
      }
      else if(editForm.hasClass('news') && !projekt) {
        alert(lm_translations['choose_project']);
      }
      else {
        var isError = false;
        $('#validation-errors').remove();
        $('<div id="validation-errors"></div>').insertAfter("#acf-form-data");
        //$('.acf-accordion.-open .is-required input[type="text"]:not(.hasDatepicker)').each(function(){
        $('.acf-accordion.-open .is-required input[type="text"]').each(function(){
          if(!$(this).val() && $(this).attr("id")) {
            if($(this).hasClass('hasDatepicker')) {
              var labeltext = $('th[data-name="datum"] label').text().slice(0,-2);
            }
            else {
              var labeltext = $('label[for="'+$(this).attr("id")+'"]').text().slice(0,-2);
            }
            $('#validation-errors').append("<p>"+lm_translations['please_fill_out']+": "+labeltext+"</p>");
            isError = true;
          }
        });
        if(!isError) {
          $('#validation-errors').hide();
          $('#btn-back').attr('disabled',false);
          if(!$('.top-bar').length || $('.top-bar').length == 0) {
            var topbar = document.createElement("div");
            topbar.classList.add('top-bar');
            var logo = $('.acf-field-image[data-name="logo_'+lang+'"] .acf-image-uploader.has-value .image-wrap img');
            if(logo.length) {
              $(logo[0]).clone().appendTo(topbar);
            }
            var topbar_title = document.createElement("span");
            topbar_title.classList.add('title');
            topbar_title.innerText = titel;
            $(topbar).append(topbar_title);
            $('.acf-form-fields.-top').prepend(topbar);
          }
          else {
            $('.top-bar .title').text(titel);
          }
          step++;
          showStep(step);
        }
        else {
          $('html, body').animate({
            scrollTop: 0
        }, 200);
        }
      }
    }
    else {
      step++;
      showStep(step);
    }
    if(step == (steps.length-1)) {
      $(this).hide();
      $('.acf-form-submit input').show();
    }
    return false;
  });
  $('#btn-back').click(function(e) {
    e.preventDefault();
    step--;
    showStep(step);
    if(step == 1) {
      $(this).attr('disabled',true);
    }
    $('.acf-form-submit input').hide();
    $('#btn-next').show();
    return false;
  });

  $('#btn-draft').click(function(e) {
    e.preventDefault();
    var draftInput = document.createElement("input");
    draftInput.setAttribute("type", "hidden");
    draftInput.setAttribute("id", "_acf_status");
    draftInput.setAttribute("name", "_acf_status");
    draftInput.setAttribute("value", "draft");
    $('#acf-form-data').append(draftInput);
    $($('.acf-form-submit input')[0]).click();
  });

  $('.acf-field-checkbox[data-name="translations"] input[type="checkbox"]').change(function() {
    var lang = $(this).val();
    $('.acf-field:not(.acf-field-select,.acf-field-taxonomy).lang-'+lang).toggle();
    var translations = false;
    $('.acf-field-checkbox[data-name="translations"] input[type="checkbox"]').each(function() {
      if($(this).is(":checked")) translations = true;
    });
    if(translations) {
      $('.acf-label label').addClass("show--lang");
    }
    else {
      $('.acf-label label').removeClass("show--lang");
    }
  });

  $(".acf-field[data-name='bild'] .acf-basic-uploader input[type='file']").change(function(){
    if($(this).val() && $(this).val() != '') {
      $('.acf-field.std_img_select').hide();
    }
    else {
      $('.acf-field.std_img_select').show();
    }
  });


  $(".acf-field[data-name='bild'] .acf-image-uploader input[type='hidden']").change(function(){
    if($(this).val() && $(this).val() != '') {
      $('.acf-field.std_img_select').hide();
    }
    else {
      $('.acf-field.std_img_select').show();
    }
  });

  if($(".acf-field[data-name='bild'] .acf-image-uploader.has-value").length && $(".acf-field[data-name='bild'] .acf-image-uploader.has-value").length > 0) {
    $('.acf-field.std_img_select').hide();
  }

  /*if($('.acf-flexible-content textarea.wp-editor-area').length && $('.acf-flexible-content textarea.wp-editor-area').length > 0) {
    $('.acf-flexible-content textarea.wp-editor-area').each(function() {
      tinymce.init({
        selector: '#'+$(this).attr('id')
      });
    });
  }

  setTimeout(function() {
    var targetNodes = $('.acf-flexible-content');
    var myObserver = new MutationObserver(mutationHandler);
    var obsConfig = { childList: true, characterData: true, attributes: true, subtree: true };

    targetNodes.each(function(){
        myObserver.observe(this, obsConfig);
    } );
  },300);*/

  $('#startTranslation').click(function() {
    var selected = $("input[name='translations[]']:checked");
    var totranslate = [];
    $(selected).each(function() {
      totranslate.push($(this).val());
    });
    translateSelected(totranslate,0);
  });

});

function translateSelected(arr,index) {
  if(index < arr.length) {
    console.log("Übersetze Post ID "+arr[index]);
    $.ajax({
      type: "POST",
      dataType: "json",
      url: lm_ajax_script.ajaxurl,
      data: '&action=translate&post_id='+arr[index],
      success: function (data) {
        if(data) {
          console.log(data);
          translateSelected(arr,(index+1));
        }
      },
      error: function (request, status, error) {
        console.log(request.responseText);
      }
    });
  }
  else {
    alert('Übersetzung abgeschlossen');
    window.location.reload();
  }
}

var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

var trackChange = function(element) {
  var observer = new MutationObserver(function(mutations, observer) {
    if(mutations[0].attributeName == "value") {
        $(element).trigger("change");
    }
  });
  observer.observe(element, {
    attributes: true
  });
}

/*function mutationHandler (mutationRecords) {
    mutationRecords.forEach ( function (mutation) {
        if (typeof mutation.addedNodes == "object" && mutation.target.className.includes('ui-sortable')) {
            var textareas = $(mutation.target).find('.wp-editor-area');
            if(textareas.length > 0) {
              textareas.each (function(){
                //console.log($('#wp-'+this.id+'-editor-container .mce-top-part'));
                //$('#wp-'+this.id+'-editor-container .mce-top-part').hide();
                tinymce.init({
                  selector: '#'+this.id
                });
                console.log($('#'+this.id));
              } );
            }
        }
    });
}*/

// Just pass an element to the function to start tracking
if($(".acf-field[data-name='bild'] .acf-image-uploader input[type='hidden']").length && $(".acf-field[data-name='bild'] .acf-image-uploader input[type='hidden']").length > 0) {
  trackChange( $(".acf-field[data-name='bild'] .acf-image-uploader input[type='hidden']")[0] );
}

function showStep(step) {

  /*if($('.acf-field[data-name="projekt"] select').length) {
    if(step == 1) {
      $('.acf-field[data-name="projekt"] select').prop('disabled', true);
    }
    else {
      $('.acf-field[data-name="projekt"] select').prop('disabled', false);
    }
  }

  if($('.acf-field[data-name="netzwerk"] select').length) {
    if(step == 1) {
      $('.acf-field[data-name="netzwerk"] select').prop('disabled', true);
    }
    else {
      $('.acf-field[data-name="netzwerk"] select').prop('disabled', false);
    }
  }*/
  if(editForm.hasClass('event') && step == 2) {
    var projekt = $($('.acf-field[data-name="projekt"] select')[0]).val();
    if(projekt) {
      $('.acf-field[data-name="themen"]').hide();
      $('.acf-field[data-name="regionen"]').hide();
    }
    else {
      $('.acf-field[data-name="themen"]').show();
      $('.acf-field[data-name="regionen"]').show();
    }
  }

  $('.acf-accordion').removeClass('-open');
  $('.acf-accordion-content').hide();
  $(steps[step]).addClass('-open');
  $(steps[step]+' .acf-accordion-content').show();

  if(editForm.hasClass('event') && step == 1) {
    $('.acf-field-6207f4603be53').addClass('-open');
    $('.acf-field-6207f4603be53 .acf-accordion-content').show();
  }
  window.scrollTo(0,0);
}

